import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import '../App.scss';

const RulesAndContact: React.FC = () => {
  const handleDownload = () => {
    window.open("/Pravila-Firebird-Кviz–Politehnika-2025.pdf", "_blank");
  };

  return (
    <section id="pravila-kontakt" className="rules-contact-section">
      <Container>
        <Row className="justify-content-center">
          <Col md={8} className="text-center">
            <p className="pravila">
            Ova Pravila stupaju na snagu danom njihovog donošenja, a prema trećim licima danom javnog objavljivanja.
            </p>
            <Button onClick={handleDownload} className="rules-button">
              PRAVILA
            </Button>
          </Col>
        </Row>

        <Row className="justify-content-center mt-5 contact-margin">
          <Col className="contact-text">
            <span>KONTAKT</span>
          </Col>
        </Row>

        <Row className="justify-content-center mb-4">
          <Col md={6} className="text-center contact-info">
            <p>E-MAIL:</p>
            <p>
              <a href="mailto:office@firebird.rs" style={{ color: 'inherit', textDecoration: 'none' }}>
              office@firebird.rs
              </a>
            </p>
            <br />
            <p>Broj telefona:</p>
            <p>
              <a href="tel:+381643344881" style={{ color: 'inherit', textDecoration: 'none' }}>
                064-334-4881
              </a>
            </p>
          </Col>
        </Row>
        <Row className="justify-content-center mt-5">
          <Col md={12} className="text-center">
            <p className="text mb-4">
            Nagradni konkurs je otvoren samo za osobe koje su dobile promotivni flajer na kom se nalazi QR kod.
            </p>
            {/* <div>
              <img src="../maxi-mega.png" alt="MEGA Maxi" className="img-fluid"/>
              <div>
              <img src="../maxi-mega.png" alt="MEGA Maxi" className="img-fluid"/>
            </div>
            <div>
              <img src="../maxi-mega.png" alt="MEGA Maxi" className="img-fluid"/>
            </div>
            </div> */}
          </Col>
          <Col xs={4} sm={4} md={3} lg={2} className="text-center mb-3">
            <img src="../logo-no-text.png" alt="MEGA Maxi" className="img-fluid" />
            <p className="text-center politehnika-label fs-5">Академија струковних студија Политехника</p>
          </Col>
          <Col xs={4} sm={4} md={3} lg={2} className="text-center mb-3">
            <img src="../logo-redo.png" alt="MEGA Maxi" className="img-fluid" />
          </Col>
          {/* <Col xs={6} sm={4} md={3} lg={2} className="text-center mb-3">
            <img src="../maxi-online.png" alt="MEGA Maxi" className="img-fluid" />
          </Col>
          <Col xs={6} sm={4} md={3} lg={2} className="text-center mb-3">
            <img src="../shop-go.png" alt="MEGA Maxi" className="img-fluid" />
          </Col> */}
        </Row>
      </Container>
    </section>
  );
};

export default RulesAndContact;
